export const Content = (props) => {
  return (
    <>{props.content.map(para => <p>{para}</p>)}</>
  )
}